import { useMutation, useQueryClient } from '@tanstack/react-query';
import consentTemplatesApi from '@/features/dashboard/consentTemplates/api/consentTemplatesApi.ts';
import { consentTemplatesApiQueryKeys } from '@/features/dashboard/consentTemplates/api/consentTemplatesApi.queryKeys.ts';
import { ConsentTemplateErrorKeys } from '@/features/dashboard/consentTemplates/api/consentTemplateErrors.ts';
import { isKnownBackendErrorKey } from '@/lib/api/exception.ts';
import { toast } from 'sonner';

export default function useDeleteConsentTemplate() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => consentTemplatesApi.remove(id),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: consentTemplatesApiQueryKeys.all(),
      });
      toast.success('Szablon zgody został usunięty');
    },
    onError: (error: Error) => {
      if (isKnownBackendErrorKey(error, ConsentTemplateErrorKeys.IN_USE)) {
        toast.error('Nie można usunąć szablonu', {
          description:
            'Szablon jest przypisany do co najmniej jednego turnusu. Najpierw odepnij tę zgodę z turnusów, a następnie spróbuj ponownie.',
        });
        return;
      }
      toast.error('Wystąpił błąd', {
        description:
          error.message || 'Wystąpił błąd podczas usuwania szablonu zgody.',
      });
    },
  });
}
